import { FC, useState, useEffect } from 'react';
import MuiButton from '@material-ui/core/Button';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import { ClassificationItem } from '../../common/documents/ClassificationDocument';
import { CompanyEditListButton } from './CompanyEditListButton';
import { companyEditState } from '../../context/companyEditStore';
import { ListSelect } from '../select/ListSelect';
import { Color } from '../Theme';
import { Header } from '../Header';
import { useScopedState } from '../../lib/state';
import { WWWCompanyEditSelectFields } from '../../common/documents/WWWCompanyEditDocument';
import { SelectedCountPair } from '../../context/advancedSearchStore';

export interface CompanyEditSelectProps {
  parentTitle: string;
  title: string;
  path: keyof WWWCompanyEditSelectFields;
  items: ClassificationItem[];
  onOpen: (component: JSX.Element) => void;
  onClose: () => void;
}

const CompanyEditSelectComponent: FC<
  CompanyEditSelectProps & { id: string; selected: string[]; onSelect: (data: { selected: string[] }) => void }
> = ({ id, parentTitle, title, items, selected, onSelect, onClose }) => {
  return (
    <>
      <div>
        <MuiButton color="primary" startIcon={<ArrowLeftIcon size={16} color={Color.primary} />} size="small" onClick={onClose}>
          {parentTitle}
        </MuiButton>
      </div>

      <Header>{title}</Header>

      <ListSelect id={id} selected={selected} onSelect={onSelect} showCount items={items} />
    </>
  );
};

/**
 * Render a button that when clicked opens a select component for editing
 */
export const CompanyEditSelect: FC<CompanyEditSelectProps> = (props) => {
  const { title, path, onOpen } = props;
  const { set, ...editState } = useScopedState(companyEditState, [path]);
  const { selected, count } = editState[path];

  // Unique ID for the select component
  const id = `company-edit-${path}`;

  const handleSelect = ({ selected, count }: SelectedCountPair) => {
    set({ [path]: { selected, count } } as any);
  };

  /** Render the actual select component, will be called by the edit dialog when requested */
  const renderSelectComponent = () => <CompanyEditSelectComponent {...{ id, selected, onSelect: handleSelect, ...props }} />;

  const handleEditButtonClick = () => {
    onOpen(renderSelectComponent());
  };

  return (
    <CompanyEditListButton count={count} onClick={handleEditButtonClick}>
      {title}
    </CompanyEditListButton>
  );
};
